import { readErrorMessage } from '@Components/util/utils'
import { PamAccountStatusErrorCode } from './types'

export const ACCOUNT_STATUS_ERROR_FALLBACK = 'Something went wrong. Please try again.'

const STALE_STATUS = "This account's status has already changed. Refresh to see the latest."

const ACCOUNT_STATUS_ERROR_COPY: Record<PamAccountStatusErrorCode, string> = {
  [PamAccountStatusErrorCode.PLAYER_ALREADY_DEACTIVATED]: STALE_STATUS,
  [PamAccountStatusErrorCode.PLAYER_NOT_DEACTIVATED]: STALE_STATUS,
  [PamAccountStatusErrorCode.CLERK_USER_MISSING]:
    "This player's sign-in account no longer exists. Contact engineering.",
  [PamAccountStatusErrorCode.REASON_REQUIRED]: 'Enter a reason.',
}

const isAccountStatusErrorCode = (code: string): code is PamAccountStatusErrorCode => {
  return Object.values<string>(PamAccountStatusErrorCode).includes(code)
}

/** Staff-facing copy for a failed reactivate or deactivate. */
export const readAccountStatusError = async (error: unknown): Promise<string> => {
  const code = await readErrorMessage(error, '')
  if (isAccountStatusErrorCode(code)) {
    return ACCOUNT_STATUS_ERROR_COPY[code]
  }
  return ACCOUNT_STATUS_ERROR_FALLBACK
}
